import { render, staticRenderFns } from "../templates/normal_fcont_168.html?vue&type=template&id=8f28fe3e&scoped=true&"
import script from "./normal_fcont_168.vue?vue&type=script&lang=js&"
export * from "./normal_fcont_168.vue?vue&type=script&lang=js&"
import style0 from "./normal_fcont_168.vue?vue&type=style&index=0&id=8f28fe3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f28fe3e",
  null
  
)

export default component.exports